import React from 'react';
import { Button, Display, QuickTypes } from 'Views/Components/Button/Button';
import useScreenSize from 'Hooks/useScreenSize';
import { IIconProps } from 'Views/Components/Helpers/Common';
import classnames from 'classnames';

export interface WizardStepsButton {
	title: string,
	icon?: IIconProps,
	onClick: () => void,
	quickTypes?: QuickTypes,
	display?: Display,
	disabled?: boolean,
	className?: string,
	testId?: string,
	ariaLabel?: string,
	overrideRender?: (buttonProps?: WizardStepsButton, button?: React.ReactNode) => React.ReactNode
}

interface WizardStepsProps {
	rightButtons?: WizardStepsButton[],
	leftButtons?: WizardStepsButton[],
}

const WizardSteps = (props: WizardStepsProps) => {
	const {
		leftButtons,
		rightButtons,
	} = props;
	const isMobile = useScreenSize();

	const renderButton = (button: WizardStepsButton) => {
		const btnElement = (
			<Button
				key={button.title}
				onClick={button.onClick}
				quickTypes={button.quickTypes ?? QuickTypes.None}
				display={button.display ?? Display.None}
				className={classnames(
					button.className,
					{ 'btn--icon-only': isMobile },
				)}
				icon={button.icon}
				disabled={button.disabled}
				testId={button.testId}
				buttonProps={{
					'aria-label': button.ariaLabel,
				}}
			>
				{isMobile ? '' : button.title}
			</Button>
		);

		if (button.overrideRender) {
			return button.overrideRender(button, btnElement);
		}

		return btnElement;
	};

	return (
		<section className="steps-navigator">
			<div className="left">
				{leftButtons?.map(renderButton)}
			</div>
			<div className="right">
				{rightButtons?.map(renderButton)}
			</div>
		</section>
	);
};

export default WizardSteps;
